
  import {defineComponent, ref, watchEffect} from "vue";
  import {useStore} from "vuex";
  import {ApiGetters, FormGetters} from './../../Store/index';
  import {isEmpty} from './../../Composables/functions';

  import WarningTriangleIcon from "./../Icons/WarningTriangle.vue";

  export default defineComponent({
    name: "HsnTsnWarningComponent",
    components: {
      WarningTriangleIcon
    },

    props: {
      step: Number,
      name: {
        type: String,
        default: ''
      }
    },

    setup(props) {
      // Access the Vuex store
      const store = useStore();

      const useHsnTsn = ref(false),
          inputsWereChanged = ref(false),
          carCount = ref(0),
          carCountHsnTsn = ref(0);

      watchEffect(() => {
        useHsnTsn.value = store.getters[`form/${FormGetters.GET_INPUTS}`].useHsnTsn.value;
        carCount.value = store.getters[`form/${FormGetters.GET_DATA}`].carCount.value;
        carCountHsnTsn.value = store.getters[`form/${FormGetters.GET_DATA}`].carCountHsnTsn.value;

        if (
            store.getters[`form/${FormGetters.GET_INPUTS}`].fieldHSN.value !== '' &&
            store.getters[`form/${FormGetters.GET_INPUTS}`].fieldTSN.value !== ''
        ) {
          inputsWereChanged.value = true;
        }
      });

      const showElement = () => {
          const availableSteps = Array.from(store.getters[`form/${FormGetters.GET_DATA}`].availableSteps.value),
              firstRegistrationValue = store.getters[`form/${FormGetters.GET_INPUTS}`].firstRegistration.value,
              mileage = store.getters[`form/${FormGetters.GET_INPUTS}`].mileage.value;

        return useHsnTsn.value &&
            inputsWereChanged.value &&
            availableSteps[availableSteps.length - 1] === props.step &&
            store.getters[`api/${ApiGetters.GET_ON_GOING_REQUEST}`] === 0 &&
            (carCountHsnTsn.value === 0 || carCount.value === 0) &&
            !isEmpty(mileage) && !isEmpty(firstRegistrationValue);
      };

      return {
        inputsWereChanged,
        useHsnTsn,
        carCount,
        carCountHsnTsn,
        showElement
      }
    }
  })
